import React from 'react';
import { Dropdown } from '@beef/ui-kit';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import { setCatalogDisplayType, toggleCatalogSortBy } from 'store/ProductCatalog/controls/actions';
import {
  getCatalogSortByOptions,
  getCatalogActiveSortBy,
} from 'store/ProductCatalog/controls/selectors.jsx';
import FiltersButton from 'pages/ProductCatalog/components/FiltersButton';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

function ViewFiltersMobile({ sortByOptions, activeSortBy, onSortByChange, showButton }) {
  return (
    <div className={cx('wrap')}>
      {showButton ?
        <div className={cx('fbutton')}>
          <FiltersButton isMobile />
        </div>
      : null}
      <div className={cx('dropdownWrap', 'mobDrop')}>
        <Dropdown
          onChange={onSortByChange}
          options={sortByOptions}
          theme="main"
          value={activeSortBy}
        />
      </div>
    </div>
  );
}

ViewFiltersMobile.propTypes = {
  /** props from redux */
  activeSortBy: PropTypes.string,
  sortByOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.node,
    }),
  ),
  onSortByChange: PropTypes.func,
  showButton: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  sortByOptions: getCatalogSortByOptions(state),
  activeSortBy: getCatalogActiveSortBy(state),
});

const mapDispatchToProps = {
  onDisplayTypeChange: setCatalogDisplayType,
  onSortByChange: toggleCatalogSortBy,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewFiltersMobile);
